/* multipack-collection.js — v4.7 */
(function () {
  'use strict';

  var RENDER_TIMEOUT_MS = 12000;
  var renderQueue = [];
  var renderInProgress = false;
  var dataFileCache = {};
  var productJsonCache = {};
  var activeBogosRenderView = null;
  var domWriteGuardBypass = false;
  var BOGOS_VIEW_CLASS = 'bogos-volume-discount-view';
  var SEALED_BOGOS_VIEW_CLASS = 'mcp-bogos-volume-discount-view';
  var STABLE_BOGOS_HOST_CLASS = 'mcp-bogos-stable-host';
  /* Global URL cache: once we've found the CDN URL from any product's HTML,
     reuse it for all subsequent products — skip the HTML fetch entirely. */
  var cachedDataFileUrl = null;
  /* Generated once per page-session so all re-injects share the same URL and
     hit the browser's HTTP cache (near-instant) instead of re-fetching the CDN
     every time. A fresh token on each page load ensures stale data is never used. */
  var BOGOS_INJECT_TOKEN = '_mcp=' + Date.now();
  var STATIC_MULTIPACK_DEFAULT_OFFER = {};
  /* No local/static offer data is allowed here.
     Source of truth for multipack cards is only BOGOS backend data loaded into window.FGSECOMAPP. */
  var STATIC_MULTIPACK_BY_HANDLE = {};
  var STATIC_MULTIPACK_HANDLE_RULES = [];

  function log() {
    try {
      console.log.apply(console, ['[MCP]'].concat(Array.prototype.slice.call(arguments)));
    } catch (_) {}
  }

  function isProtectedBogosView(node) {
    return !!(
      node &&
      node.nodeType === 1 &&
      node.classList &&
      (
        node.classList.contains(BOGOS_VIEW_CLASS) ||
        node.classList.contains(SEALED_BOGOS_VIEW_CLASS)
      ) &&
      node._mcpBogosProtected &&
      node !== activeBogosRenderView
    );
  }

  function isProtectedBogosWriteTarget(node) {
    return isProtectedBogosView(node) ||
      (
        node &&
        node.nodeType === 1 &&
        node.parentNode &&
        isProtectedBogosView(node.parentNode)
      );
  }

  function shouldBlockProtectedBogosWrite(node, value) {
    if (domWriteGuardBypass || !isProtectedBogosWriteTarget(node)) return false;

    if (typeof value !== 'string') return true;

    return value.trim() === '' || value.indexOf('bogos-volume-discount') === -1;
  }

  function installBogosDomWriteGuard() {
    if (document._mcpBogosDomWriteGuard) return;
    document._mcpBogosDomWriteGuard = true;

    var innerHtmlDescriptor = Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML');
    if (innerHtmlDescriptor && innerHtmlDescriptor.set) {
      Object.defineProperty(Element.prototype, 'innerHTML', {
        configurable: true,
        enumerable: innerHtmlDescriptor.enumerable,
        get: innerHtmlDescriptor.get,
        set: function (value) {
          if (shouldBlockProtectedBogosWrite(this, value)) {
            log('[DBG] DOM guard: blocked protected innerHTML clear');
            return;
          }
          return innerHtmlDescriptor.set.call(this, value);
        }
      });
    }

    var outerHtmlDescriptor = Object.getOwnPropertyDescriptor(Element.prototype, 'outerHTML');
    if (outerHtmlDescriptor && outerHtmlDescriptor.set) {
      Object.defineProperty(Element.prototype, 'outerHTML', {
        configurable: true,
        enumerable: outerHtmlDescriptor.enumerable,
        get: outerHtmlDescriptor.get,
        set: function (value) {
          if (shouldBlockProtectedBogosWrite(this, value)) {
            log('[DBG] DOM guard: blocked protected outerHTML clear');
            return;
          }
          return outerHtmlDescriptor.set.call(this, value);
        }
      });
    }

    var textContentDescriptor = Object.getOwnPropertyDescriptor(Node.prototype, 'textContent');
    if (textContentDescriptor && textContentDescriptor.set) {
      Object.defineProperty(Node.prototype, 'textContent', {
        configurable: true,
        enumerable: textContentDescriptor.enumerable,
        get: textContentDescriptor.get,
        set: function (value) {
          if (shouldBlockProtectedBogosWrite(this, value)) {
            log('[DBG] DOM guard: blocked protected textContent clear');
            return;
          }
          return textContentDescriptor.set.call(this, value);
        }
      });
    }

    var nativeReplaceChild = Node.prototype.replaceChild;
    Node.prototype.replaceChild = function (newChild, oldChild) {
      if (!domWriteGuardBypass && (isProtectedBogosView(oldChild) || isProtectedBogosView(this))) {
        log('[DBG] DOM guard: blocked protected replaceChild');
        return oldChild;
      }
      return nativeReplaceChild.call(this, newChild, oldChild);
    };

    if (Element.prototype.replaceChildren) {
      var nativeReplaceChildren = Element.prototype.replaceChildren;
      Element.prototype.replaceChildren = function () {
        if (!domWriteGuardBypass && isProtectedBogosView(this)) {
          log('[DBG] DOM guard: blocked protected replaceChildren');
          return;
        }
        return nativeReplaceChildren.apply(this, arguments);
      };
    }
  }

  function installSealedBogosStyleAlias() {
    if (document._mcpBogosStyleAlias) return;
    document._mcpBogosStyleAlias = true;

    var css = [
      '.' + STABLE_BOGOS_HOST_CLASS + '{display:block;}',
      '.' + SEALED_BOGOS_VIEW_CLASS + '{display:block;}',
      '.' + STABLE_BOGOS_HOST_CLASS + ' .bogos-volume-discount-button-add{pointer-events:auto!important;cursor:pointer!important;opacity:1!important;}',
      '[data-mcp-bogos-source-view="1"]{display:none!important;}'
    ];

    Array.prototype.slice.call(document.styleSheets).forEach(function (sheet) {
      var rules;

      try {
        rules = sheet.cssRules;
      } catch (_) {
        return;
      }

      Array.prototype.slice.call(rules || []).forEach(function (rule) {
        if (!rule.selectorText) return;

        if (rule.selectorText.indexOf('.MultipackTeaser__BogosMount') !== -1) {
          css.push(
            rule.cssText
              .replace(/\.MultipackTeaser__BogosMount/g, '.' + STABLE_BOGOS_HOST_CLASS)
              .replace(new RegExp('\\.' + BOGOS_VIEW_CLASS + '(?=[\\s\\.#:\\[,>{])', 'g'), '.' + SEALED_BOGOS_VIEW_CLASS)
          );
          return;
        }

        if (rule.selectorText.indexOf('.' + BOGOS_VIEW_CLASS) !== -1) {
          css.push(
            rule.cssText.replace(
              new RegExp('\\.' + BOGOS_VIEW_CLASS + '(?=[\\s\\.#:\\[,>{])', 'g'),
              '.' + SEALED_BOGOS_VIEW_CLASS
            )
          );
        }
      });
    });

    var style = document.createElement('style');
    style.setAttribute('data-mcp-bogos-style-alias', '1');
    style.textContent = css.join('\n');
    document.head.appendChild(style);
  }

  function sealBogosView(view) {
    if (!view) return;

    var mount = getMountFromElement(view);
    if (!mount) {
      if (!hasUsefulBogosContent(view)) {
        if (activeBogosRenderView === view) activeBogosRenderView = null;
        return;
      }

      view.removeAttribute('id');
      view._mcpBogosProtected = true;
      view.setAttribute('data-mcp-bogos-sealed', '1');
      view.classList.add(SEALED_BOGOS_VIEW_CLASS);
      view.classList.remove(BOGOS_VIEW_CLASS);
      view.style.display = '';
      if (activeBogosRenderView === view) activeBogosRenderView = null;
      return;
    }

    if (!hasUsefulBogosContent(view)) {
      if (activeBogosRenderView === view) activeBogosRenderView = null;
      return;
    }

    syncFormStateToMarkup(view);

    var stableHost = getStableBogosHost(mount, true);
    var stableView = view.cloneNode(true);

    stableView.removeAttribute('id');
    stableView._mcpBogosProtected = true;
    stableView.setAttribute('data-mcp-bogos-sealed', '1');
    stableView.classList.add(SEALED_BOGOS_VIEW_CLASS);
    stableView.classList.remove(BOGOS_VIEW_CLASS);
    stableView.style.display = '';
    convertStableBogosButtonsToLinks(stableView);

    domWriteGuardBypass = true;
    try {
      stableHost.innerHTML = '';
      stableHost.appendChild(stableView);
    } finally {
      domWriteGuardBypass = false;
    }

    view.removeAttribute('id');
    view.removeAttribute('data-mcp-bogos-sealed');
    view.removeAttribute('data-mcp-bogos-source-view');
    view._mcpBogosProtected = false;
    view.classList.add(BOGOS_VIEW_CLASS);
    view.classList.remove(SEALED_BOGOS_VIEW_CLASS);
    view.style.display = 'none';
    view.innerHTML = '';

    if (activeBogosRenderView === view) activeBogosRenderView = null;
  }

  function getProductUrlForBogosElement(el) {
    var card = getCardFromElement(el);
    var root = getBogosRootFromElement(el);
    var cardLink = card && card.querySelector('a[href*="/products/"]');
    var handle = root && root.getAttribute('data-product-handle');

    if (cardLink && cardLink.getAttribute('href')) return cardLink.getAttribute('href');
    if (handle) return '/products/' + handle;

    return '';
  }

  function convertStableBogosButtonsToLinks(root) {
    if (!root) return;

    root.querySelectorAll('button.bogos-volume-discount-button-add').forEach(function (button) {
      var href = getProductUrlForBogosElement(button);
      var link = document.createElement('a');

      Array.prototype.slice.call(button.attributes).forEach(function (attr) {
        if (attr.name === 'type') return;
        link.setAttribute(attr.name, attr.value);
      });

      link.href = href || '#';
      link.setAttribute('data-mcp-product-link', '1');
      link.innerHTML = button.innerHTML;
      button.parentNode.replaceChild(link, button);
    });
  }

  function exposeSealedBogosView(view, duration) {
    if (!view || !view.hasAttribute('data-mcp-bogos-sealed')) return;

    view.classList.add(BOGOS_VIEW_CLASS);
  }

  function applyProductContextFromView(view) {
    if (!view) return;

    var handle = view.getAttribute('data-product-handle');
    var pid = parseInt(view.getAttribute('data-product-id'), 10);
    var productJson = productJsonCache[handle];

    window.Shopify = window.Shopify || {};

    if (productJson) {
      window.Shopify.current_product = productJson;
      window.Shopify.product = productJson;
    } else if (handle || pid) {
      window.Shopify.current_product = { id: pid, handle: handle };
      window.Shopify.product = { id: pid, handle: handle };
    }
  }

  function activateBogosInteractionContext(mount) {
    if (!mount || !mount._mcpBogosRendered) return null;

    var view = getAnyBogosView(mount);
    if (!view) return null;

    document.querySelectorAll('#bogos-volume-discount-view').forEach(function (el) {
      if (el !== view) el.removeAttribute('id');
    });

    document.querySelectorAll('[data-mcp-bogos-sealed].' + BOGOS_VIEW_CLASS).forEach(function (el) {
      if (el !== view) el.classList.remove(BOGOS_VIEW_CLASS);
    });

    applyProductContextFromView(view);
    view.id = 'bogos-volume-discount-view';

    if (view.hasAttribute('data-mcp-bogos-sealed')) {
      view.classList.add(BOGOS_VIEW_CLASS);
    }

    return view;
  }

  function getStableBogosHost(mount, create) {
    if (!mount) return null;

    var teaser = mount.closest('.MultipackTeaser') || mount.parentNode;
    if (!teaser) return null;

    var host = teaser.querySelector('[data-mcp-bogos-stable-host]');
    if (!host && create) {
      host = document.createElement('div');
      host.className = STABLE_BOGOS_HOST_CLASS;
      host.setAttribute('data-mcp-bogos-stable-host', '1');
      mount.parentNode.insertBefore(host, mount);
    }

    if (host) host._mcpBogosMount = mount;

    return host;
  }

  function getCardFromElement(el) {
    while (el && el.nodeType === 1) {
      if (el.hasAttribute && el.hasAttribute('data-mp-card')) return el;
      el = el.parentNode;
    }

    return null;
  }

  function getMountFromElement(el) {
    while (el && el.nodeType === 1) {
      if (el.hasAttribute && el.hasAttribute('data-mp-bogos-mount')) return el;
      if (el.hasAttribute && el.hasAttribute('data-mcp-bogos-stable-host')) return el._mcpBogosMount || null;
      el = el.parentNode;
    }

    return null;
  }

  function getSelectedTierIndex(card) {
    if (!card) return 1;

    var checked = card.querySelector('.bogos-volume-discount_item-container input[type="radio"]:checked');

    if (!checked) {
      checked = card.querySelector('.bogos-volume-discount-item input[type="radio"]:checked');
    }

    if (!checked) {
      checked = card.querySelector('.bogos-volume-discount-tier-input:checked');
    }

    if (!checked) return 1;

    var tierContainer = checked.closest('.bogos-volume-discount_item-container');
    if (!tierContainer) return 1;

    var containers = Array.prototype.slice.call(
      card.querySelectorAll('.bogos-volume-discount_item-container')
    );

    var index = containers.indexOf(tierContainer);

    if (index < 0) return 1;

    return index + 1;
  }

  function normalizeMultipackImageFrame(img) {
    var card;
    var wrapper;
    var aspect;
    var frameHeight = 'clamp(240px, 24vw, 320px)';

    if (!img || !img.closest) return;

    card = img.closest('[data-mp-card]');
    if (!card) return;

    wrapper = img.closest('.ProductItem__ImageWrapper');
    aspect = img.closest('.AspectRatio');

    [wrapper, aspect].forEach(function (frame) {
      if (!frame || !frame.style) return;

      frame.style.setProperty('height', frameHeight, 'important');
      frame.style.setProperty('min-height', '0', 'important');
      frame.style.setProperty('max-height', frameHeight, 'important');
      frame.style.setProperty('padding-bottom', '0', 'important');
      frame.style.setProperty('display', 'flex', 'important');
      frame.style.setProperty('align-items', 'center', 'important');
      frame.style.setProperty('justify-content', 'center', 'important');
      frame.style.setProperty('overflow', 'hidden', 'important');
    });

    img.style.setProperty('position', 'static', 'important');
    img.style.setProperty('display', 'block', 'important');
    img.style.setProperty('width', '100%', 'important');
    img.style.setProperty('height', '100%', 'important');
    img.style.setProperty('max-width', '78%', 'important');
    img.style.setProperty('max-height', '78%', 'important');
    img.style.setProperty('object-fit', 'contain', 'important');
    img.style.setProperty('object-position', 'center', 'important');
    img.style.setProperty('transform', 'none', 'important');
    img.style.setProperty('margin', 'auto', 'important');
  }

  function forceImageLoad(img, url, alt) {
    if (!img || !url) return;

    if (!img.getAttribute('data-mp-default-src')) {
      img.setAttribute('data-mp-default-src', img.getAttribute('src') || '');
      img.setAttribute('data-mp-default-data-src', img.getAttribute('data-src') || '');
      img.setAttribute('data-mp-default-alt', img.getAttribute('alt') || '');
    }

    img.setAttribute('src', url);
    img.setAttribute('data-src', url);
    img.setAttribute('data-original-src', url);

    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-widths');
    img.removeAttribute('sizes');
    img.removeAttribute('data-sizes');

    if (alt) img.setAttribute('alt', alt);

    img.classList.remove('Image--lazyLoad');
    img.classList.remove('Image--fadeIn');
    img.classList.add('Image--lazyLoaded');

    normalizeMultipackImageFrame(img);
  }

  function restoreDefaultProductImage(img) {
    if (!img) return;

    var defaultSrc = img.getAttribute('data-mp-default-src') || '';
    var defaultDataSrc = img.getAttribute('data-mp-default-data-src') || '';
    var defaultAlt = img.getAttribute('data-mp-default-alt') || '';

    if (defaultSrc) img.setAttribute('src', defaultSrc);
    if (defaultDataSrc) img.setAttribute('data-src', defaultDataSrc);
    if (defaultAlt) img.setAttribute('alt', defaultAlt);

    normalizeMultipackImageFrame(img);
  }

  function updateMultipackImage(card) {
    if (!card) return;

    var staticTierIndex = parseInt(card.getAttribute('data-mp-static-image-tier'), 10);
    var tierIndex = staticTierIndex || getSelectedTierIndex(card);
    var staticImageUrl = card.getAttribute('data-mp-static-image-url') || '';
    var staticImageAlt = card.getAttribute('data-mp-static-image-alt') || '';
    var url = staticImageUrl || card.getAttribute('data-mp-image-' + tierIndex) || '';
    var alt = staticImageAlt || card.getAttribute('data-mp-image-' + tierIndex + '-alt') || '';

    var mainImage = card.querySelector('[data-mp-main-image]');

    if (!mainImage) {
      mainImage = card.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');
    }

    if (!mainImage) return;

    if (!url) {
      restoreDefaultProductImage(mainImage);
      card.removeAttribute('data-mp-current-tier');
      card.removeAttribute('data-mp-current-image');
      return;
    }

    forceImageLoad(mainImage, url, alt);
    card.setAttribute('data-mp-current-tier', String(tierIndex));
    card.setAttribute('data-mp-current-image', url);
  }

  function updateAllMultipackImages() {
    document.querySelectorAll('[data-mp-card]').forEach(updateMultipackImage);
  }

  function applyStaticMultipackImage(card, offer, offerIndex) {
    var cardOfferIndex;
    var positionIndex;
    var tierIndex;
    var url;
    var alt;
    var mainImage;

    if (!card) return;

    /* Image mapping is tied to the generated card order, not to the BOGOS tier.
       First rendered multipack card  -> product metafield custom.multipack_image
       Second rendered multipack card -> product metafield custom.multipack_image_2
       This prevents FGSECOMAPP tier values like quantity/tier from overriding
       the collection-card images. */
    cardOfferIndex = parseInt(card.getAttribute('data-mp-static-offer-index'), 10);
    positionIndex = !isNaN(cardOfferIndex) ? cardOfferIndex : (parseInt(offerIndex, 10) || 0);
    tierIndex = positionIndex + 1;

    /* Always use product metafield images printed by Liquid:
       first generated card -> data-mp-image-1, second generated card -> data-mp-image-2.
       Do not use FGSECOMAPP variant images here. */
    url = card.getAttribute('data-mp-image-' + tierIndex) || '';
    alt = card.getAttribute('data-mp-image-' + tierIndex + '-alt') || '';

    card.setAttribute('data-mp-static-image-tier', String(tierIndex));
    card.removeAttribute('data-mp-static-image-url');
    card.removeAttribute('data-mp-static-image-alt');

    mainImage = card.querySelector('[data-mp-main-image]');
    if (!mainImage) {
      mainImage = card.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');
    }

    if (!mainImage) return;

    if (!url) {
      restoreDefaultProductImage(mainImage);
      card.removeAttribute('data-mp-current-image');
      return;
    }

    forceImageLoad(mainImage, url, alt);
    card.setAttribute('data-mp-current-tier', String(tierIndex));
    card.setAttribute('data-mp-current-image', url);
  }

  /* Called in capture phase when user interacts with a BOGOS tier.
     Ensures id="bogos-volume-discount-view" and Shopify.current_product
     point to the product being interacted with BEFORE BOGOS fires its
     own "Delay rerender" handler — preventing re-render into wrong element.

     Guard: skip while the render queue is still running. During loading each
     product's setActiveBogosTarget already manages the id correctly, and
     firing this prematurely (e.g. from BOGOS's own programmatic change events
     during rendering) would conflict with the active render cycle. */
  function restoreBogosContext(mount) {
    if (renderInProgress || renderQueue.length > 0) {
      log('[DBG] restoreBogosContext: queue busy — skipping');
      return;
    }
    if (!mount || !mount._mcpBogosRendered) return;

    var visibleView = getAnyBogosView(mount);
    var view = getBogosView(mount);
    var contextView = visibleView || view;

    if (!contextView) return;

    if (visibleView && visibleView.hasAttribute('data-mcp-bogos-sealed')) {
      activateBogosInteractionContext(mount);
      log('[DBG] restoreBogosContext: stable sealed view activated for', visibleView.getAttribute('data-product-handle'));
      return;
    }

    if (!view) return;

    if (view.hasAttribute('data-mcp-bogos-sealed')) {
      activateBogosInteractionContext(mount);
      log('[DBG] restoreBogosContext: sealed view activated for', view.getAttribute('data-product-handle'));
      return;
    }

    document.querySelectorAll('#bogos-volume-discount-view').forEach(function (el) {
      if (el !== view) el.removeAttribute('id');
    });

    view.id = 'bogos-volume-discount-view';

    applyProductContextFromView(view);
    log('[DBG] restoreBogosContext: restored for', view.getAttribute('data-product-handle'));
  }

  function setupMultipackImageEvents() {
    if (document._mcpMultipackImages) return;
    document._mcpMultipackImages = true;

    document.addEventListener('change', function (e) {
      var target = e.target;
      if (!target || !target.matches) return;

      var eventMount = getMountFromElement(target);
      if (eventMount) {
        activateBogosInteractionContext(eventMount);
      }

      if (
        target.matches('.bogos-volume-discount-tier-input') ||
        target.matches('.bogos-volume-discount-item input[type="radio"]') ||
        target.matches('.bogos-volume-discount_item-container input[type="radio"]')
      ) {
        /* Restore id + current_product to this product's view so BOGOS's
           Delay-rerender (triggered by the tier change) can find its target
           and re-render the updated selection instead of leaving it blank. */
        restoreBogosContext(eventMount);

        var card = getCardFromElement(target);

        setTimeout(function () {
          updateMultipackImage(card);
        }, 50);
      }
    }, true);

    document.addEventListener('click', function (e) {
      var el = e.target;
      var eventMount = getMountFromElement(el);

      if (eventMount) {
        activateBogosInteractionContext(eventMount);
      }

      /* NOTE: restoreBogosContext is intentionally NOT called here.
         Calling it on every click is too broad — BOGOS itself dispatches
         programmatic click events during rendering, which would cause
         spurious restoreBogosContext fires that interfere with the active
         render cycle.  The change listener below covers all actual
         tier / variant selections that need the id restored. */
      while (el && el.nodeType === 1) {
        if (
          el.classList &&
          (
            el.classList.contains('bogos-volume-discount_item-container') ||
            el.classList.contains('bogos-volume-discount-item') ||
            el.classList.contains('bogos-volume-discount-tier-label')
          )
        ) {
          var card = getCardFromElement(el);

          setTimeout(function () {
            updateMultipackImage(card);
          }, 100);

          return;
        }

        el = el.parentNode;
      }
    }, true);
  }

  function pinDropdownFixed(optDiv, trigger) {
    var rect = trigger.getBoundingClientRect();
    var vph = window.innerHeight;
    var MAX_H = 220;
    var MIN_H = 80;
    var GAP = 4;

    var spaceBelow = vph - rect.bottom - GAP;
    var spaceAbove = rect.top - GAP;
    var openDown = spaceBelow >= MIN_H || spaceBelow >= spaceAbove;

    var top;
    var actualMaxH;

    if (openDown) {
      top = rect.bottom + GAP;
      actualMaxH = Math.min(MAX_H, Math.max(MIN_H, spaceBelow));
    } else {
      actualMaxH = Math.min(MAX_H, Math.max(MIN_H, spaceAbove));
      top = rect.top - actualMaxH - GAP;
    }

    optDiv.style.setProperty('position', 'fixed', 'important');
    optDiv.style.setProperty('top', top + 'px', 'important');
    optDiv.style.setProperty('left', rect.left + 'px', 'important');
    optDiv.style.setProperty('width', rect.width + 'px', 'important');
    optDiv.style.setProperty('z-index', '99999', 'important');
    optDiv.style.setProperty('max-height', actualMaxH + 'px', 'important');
    optDiv.style.setProperty('overflow-y', 'auto', 'important');
    optDiv.style.setProperty('overflow-x', 'hidden', 'important');
    optDiv.style.setProperty('display', 'block', 'important');

    optDiv._mcpPinned = true;
  }

  function unpinDropdown(optDiv) {
    if (!optDiv._mcpPinned) return;

    optDiv._mcpPinned = false;

    [
      'position',
      'top',
      'left',
      'width',
      'z-index',
      'max-height',
      'overflow-y',
      'overflow-x',
      'display'
    ].forEach(function (key) {
      optDiv.style.removeProperty(key);
    });
  }

  function pinVisibleDropdowns(collapse) {
    collapse.querySelectorAll('.bogos-vl-select-variant-options').forEach(function (optDiv) {
      if (optDiv._mcpPinned) return;

      var shown = window.getComputedStyle(optDiv).display !== 'none';
      if (!shown) return;

      var dropEl = optDiv.parentNode;

      while (dropEl && dropEl.nodeType === 1) {
        if (dropEl.classList && dropEl.classList.contains('bogos-vl-select-variant-dropdown')) break;
        dropEl = dropEl.parentNode;
      }

      var trigger = dropEl && dropEl.querySelector('.bogos-vl-select-variant-title-input');

      if (trigger) pinDropdownFixed(optDiv, trigger);
    });
  }

  function watchCollapse(collapse) {
    if (collapse._mcpWatched) return;
    collapse._mcpWatched = true;

    new MutationObserver(function () {
      var active = collapse.classList.contains('bogos-volume-discount-active-dropdown-select');

      if (active) {
        setTimeout(function () {
          pinVisibleDropdowns(collapse);
        }, 0);
      } else {
        collapse.querySelectorAll('.bogos-vl-select-variant-options').forEach(unpinDropdown);
      }
    }).observe(collapse, {
      attributes: true,
      attributeFilter: ['class']
    });

    new MutationObserver(function (mutations) {
      if (!collapse.classList.contains('bogos-volume-discount-active-dropdown-select')) return;

      var hasNew = false;

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          if (
            (node.classList && node.classList.contains('bogos-vl-select-variant-options')) ||
            (node.querySelector && node.querySelector('.bogos-vl-select-variant-options'))
          ) {
            hasNew = true;
          }
        });
      });

      if (hasNew) {
        setTimeout(function () {
          pinVisibleDropdowns(collapse);
        }, 0);
      }
    }).observe(collapse, {
      childList: true,
      subtree: true
    });
  }

  function processBogosMount(mount) {
    var bogosView = getAnyBogosView(mount);
    if (!bogosView) return;

    var card = getCardFromElement(mount);

    function scanCollapses() {
      mount.querySelectorAll('.bogos-volume-discount-variants-collapse').forEach(watchCollapse);
    }

    scanCollapses();

    setTimeout(function () {
      updateMultipackImage(card);
    }, 0);

    setTimeout(function () {
      updateMultipackImage(card);
    }, 300);

    if (!mount._mcpMountObs || mount._mcpMountObsTarget !== bogosView) {
      if (mount._mcpMountObs) {
        mount._mcpMountObs.disconnect();
      }

      mount._mcpMountObsTarget = bogosView;
      mount._mcpMountObs = new MutationObserver(function (mutations) {
        var needCollapses = false;
        var needImageUpdate = false;

        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;

            if (
              (node.classList && node.classList.contains('bogos-volume-discount-variants-collapse')) ||
              (node.querySelector && node.querySelector('.bogos-volume-discount-variants-collapse'))
            ) {
              needCollapses = true;
            }

            if (
              (node.classList && node.classList.contains('bogos-volume-discount_item-container')) ||
              (node.querySelector && node.querySelector('.bogos-volume-discount_item-container'))
            ) {
              needImageUpdate = true;
            }
          });
        });

        if (needCollapses) scanCollapses();

        if (needImageUpdate) {
          setTimeout(function () {
            updateMultipackImage(card);
          }, 100);
        }
      });

      mount._mcpMountObs.observe(bogosView, {
        childList: true,
        subtree: true
      });
    }
  }

  /* Snapshot-based guard: BOGOS keeps global async handlers and may clear,
     replace, or remove previously rendered views when a later "Delay rerender"
     fires. Keep a full-view snapshot per mount and restore the exact card view
     after the rerender burst settles. */
  function guardRenderedMount(mount) {
    var view = getAnyBogosView(mount);
    if (!view || mount._mcpGuarded) return;
    mount._mcpGuarded = true;
    view._mcpGuarded = true;

    syncFormStateToMarkup(view);
    var snapshot = view.outerHTML;
    var restoreTimer = null;
    var restoring = false;

    function refreshSnapshot() {
      var currentView = getAnyBogosView(mount);
      if (!hasUsefulBogosContent(currentView)) return;

      syncFormStateToMarkup(currentView);
      snapshot = currentView.outerHTML;
    }

    function scheduleRestore(label) {
      clearTimeout(restoreTimer);
      restoreTimer = setTimeout(function () {
        if (restoring) return;

        var currentView = getAnyBogosView(mount);
        if (hasUsefulBogosContent(currentView)) {
          refreshSnapshot();
          return;
        }

        restoring = true;
        if (restoreBogosViewSnapshot(mount, snapshot)) {
          log('[DBG] guardRenderedMount: restored', label || 'view');
        }
        restoring = false;
      }, 700);
    }

    new MutationObserver(function () {
      if (restoring) return;

      var currentView = getAnyBogosView(mount);
      var label = currentView && (
        currentView.getAttribute('data-product-handle') ||
        currentView.getAttribute('data-product-id')
      );

      if (hasUsefulBogosContent(currentView)) {
        clearTimeout(restoreTimer);
        refreshSnapshot();
      } else {
        scheduleRestore(label);
      }
    }).observe(mount, { childList: true, subtree: true });
  }

  function notifyThemeCart() {
    if (typeof window.refreshCartDrawerFromCartSection === 'function') {
      window.refreshCartDrawerFromCartSection();
      return;
    }

    fetch('/cart.js', {
      credentials: 'same-origin'
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll('.Header__CartCount').forEach(function (el) {
          el.textContent = cart.item_count;
        });

        var dot = document.querySelector('.Header__CartDot');
        if (dot) dot.style.display = cart.item_count > 0 ? '' : 'none';

        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: {},
            quantity: 1
          }
        }));
      });
  }

  function getBogosRootFromElement(el) {
    while (el && el.nodeType === 1) {
      if (
        el.classList &&
        (
          el.classList.contains(BOGOS_VIEW_CLASS) ||
          el.classList.contains(SEALED_BOGOS_VIEW_CLASS)
        )
      ) {
        return el;
      }

      el = el.parentNode;
    }

    return null;
  }

  function closeStableBogosDropdowns(root, exceptDropdown) {
    if (!root) return;

    root.querySelectorAll('.bogos-vl-select-variant-dropdown').forEach(function (dropdown) {
      if (dropdown === exceptDropdown) return;

      var options = dropdown.querySelector('.bogos-vl-select-variant-options');
      if (options) options.style.display = '';
      dropdown.classList.remove('mcp-bogos-dropdown-open');
    });
  }

  function getSelectedTierContainer(root) {
    if (!root) return null;

    var checked = root.querySelector('.bogos-volume-discount-tier-input:checked');
    var item = checked && checked.closest('.bogos-volume-discount_item-container');

    if (item) return item;

    return root.querySelector('.bogos-volume-discount_item-container');
  }

  function getTierCollapse(tierContainer) {
    var childCollapse = tierContainer && tierContainer.querySelector('.bogos-volume-discount-variants-collapse');
    if (childCollapse) return childCollapse;

    var el = tierContainer && tierContainer.nextElementSibling;

    while (el) {
      if (el.classList && el.classList.contains('bogos-volume-discount-variants-collapse')) {
        return el;
      }

      if (el.classList && el.classList.contains('bogos-volume-discount_item-container')) {
        return null;
      }

      el = el.nextElementSibling;
    }

    return null;
  }

  function ensureTierSelected(tierContainer) {
    if (!tierContainer) return;

    var root = getBogosRootFromElement(tierContainer);
    var input = tierContainer.querySelector('.bogos-volume-discount-tier-input');

    if (root) {
      root.querySelectorAll('.bogos-volume-discount-tier-input').forEach(function (radio) {
        radio.checked = false;
        radio.removeAttribute('checked');
      });
    }

    if (input) {
      input.checked = true;
      input.setAttribute('checked', 'checked');
    }

    if (root) {
      root.querySelectorAll('.bogos-volume-discount_item-container').forEach(function (item) {
        item.classList.remove('bogos-volume-discount-item-selected');
        item.classList.remove('mcp-bogos-tier-selected');

        var innerItem = item.querySelector('.bogos-volume-discount-item');
        if (innerItem) {
          innerItem.classList.remove('bogos-volume-discount-item-selected');
          innerItem.classList.remove('mcp-bogos-tier-selected');
        }
      });
    }

    tierContainer.classList.add('bogos-volume-discount-item-selected');
    tierContainer.classList.add('mcp-bogos-tier-selected');

    var selectedInnerItem = tierContainer.querySelector('.bogos-volume-discount-item');
    if (selectedInnerItem) {
      selectedInnerItem.classList.add('bogos-volume-discount-item-selected');
      selectedInnerItem.classList.add('mcp-bogos-tier-selected');
    }
  }

  function updateStableBogosTotal(root) {
    var tierContainer = getSelectedTierContainer(root);
    if (!tierContainer) return;

    var discountPrice = tierContainer.querySelector('.bogos-volume-discount-item-discount-price');
    var originPrice = tierContainer.querySelector('.bogos-volume-discount-item-original-price');
    var totalDiscount = root.querySelector('.bogos-volume-discount-total .bogos-volume-discount-discount-price');
    var totalOrigin = root.querySelector('.bogos-volume-discount-total .bogos-volume-discount-origin-price');

    if (discountPrice && totalDiscount) totalDiscount.innerHTML = discountPrice.innerHTML;
    if (originPrice && totalOrigin) totalOrigin.innerHTML = originPrice.innerHTML;
  }

  function updateStableBogosTierSelection(tierContainer) {
    if (!tierContainer) return;

    var root = getBogosRootFromElement(tierContainer);
    var card = getCardFromElement(tierContainer);

    ensureTierSelected(tierContainer);

    if (root) {
      var tierCount = root.querySelectorAll('.bogos-volume-discount_item-container').length;

      root.querySelectorAll('.bogos-volume-discount_item-container').forEach(function (item) {
        var collapse = getTierCollapse(item);
        if (!collapse) return;

        if (tierCount > 1 && item !== tierContainer) {
          collapse.style.display = 'none';
        } else {
          collapse.style.display = '';
        }
      });

      updateStableBogosTotal(root);
    }

    updateMultipackImage(card);
  }

  function openStableBogosDropdown(input) {
    var root = getBogosRootFromElement(input);
    var dropdown = input && input.closest('.bogos-vl-select-variant-dropdown');
    var options = dropdown && dropdown.querySelector('.bogos-vl-select-variant-options');
    var collapse = input && input.closest('.bogos-volume-discount-variants-collapse');
    var tierContainer = collapse && collapse.closest('.bogos-volume-discount_item-container');

    if (!root || !dropdown || !options) return;

    if (tierContainer) updateStableBogosTierSelection(tierContainer);

    closeStableBogosDropdowns(root, dropdown);

    var isOpen = dropdown.classList.contains('mcp-bogos-dropdown-open');
    dropdown.classList.toggle('mcp-bogos-dropdown-open', !isOpen);
    options.style.display = isOpen ? '' : 'block';
  }

  function selectStableBogosVariant(option) {
    var dropdown = option && option.closest('.bogos-vl-select-variant-dropdown');
    var input = dropdown && dropdown.querySelector('.bogos-vl-select-variant-title-input');
    var root = getBogosRootFromElement(option);

    if (!dropdown || !input || !root) return;

    input.value = (option.textContent || '').trim();
    input.setAttribute('value', input.value);
    input.setAttribute('data-variant-id', option.getAttribute('data-variant-id') || '');
    input.setAttribute('data-original-price', option.getAttribute('data-original-price') || '');

    dropdown.querySelectorAll('.bogos-vl-select-variant-option').forEach(function (el) {
      el.classList.remove('mcp-bogos-option-selected');
    });

    option.classList.add('mcp-bogos-option-selected');
    closeStableBogosDropdowns(root);
    updateStableBogosTotal(root);
    updateMultipackImage(getCardFromElement(option));
  }

  function getTierQuantity(tierContainer) {
    var title = tierContainer && tierContainer.querySelector('.bogos-volume-discount-title');
    var text = title && title.textContent ? title.textContent : '';
    var match = text.match(/(\d+)/);

    return match ? Math.max(1, parseInt(match[1], 10) || 1) : 1;
  }

  function getDefaultVariantIdForBogosRoot(root) {
    var handle = root && root.getAttribute('data-product-handle');
    var productJson = handle && productJsonCache[handle];
    var variants = productJson && productJson.variants;
    var variant = null;

    if (!variants || !variants.length) return 0;

    variant = variants.filter(function (item) {
      return item && item.available !== false;
    })[0] || variants[0];

    return variant && variant.id ? parseInt(variant.id, 10) : 0;
  }

  function buildStableBogosCartItems(root) {
    var tierContainer = getSelectedTierContainer(root);
    var collapse = getTierCollapse(tierContainer);
    var counts = {};

    if (collapse) {
      collapse.querySelectorAll('.bogos-vl-select-variant-title-input').forEach(function (input) {
        var id = parseInt(input.getAttribute('data-variant-id'), 10);
        if (!id) return;
        counts[id] = (counts[id] || 0) + 1;
      });
    }

    if (!Object.keys(counts).length) {
      var fallbackId = getDefaultVariantIdForBogosRoot(root);
      if (fallbackId) counts[fallbackId] = getTierQuantity(tierContainer);
    }

    return Object.keys(counts).map(function (id) {
      return {
        id: parseInt(id, 10),
        quantity: counts[id]
      };
    });
  }

  function addStableBogosToCart(root, button) {
    var items = buildStableBogosCartItems(root);

    if (!items.length) {
      log('[DBG] stable add-to-cart: no items for selected set', root && root.getAttribute('data-product-handle'));
      return;
    }

    if (button && button._mcpAdding) return;

    log('[DBG] stable add-to-cart: items =', JSON.stringify(items));

    if (button) {
      button._mcpAdding = true;
      button.setAttribute('data-mcp-adding', '1');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart/add failed: ' + response.status);
        return response.json();
      })
      .then(function () {
        log('[DBG] stable add-to-cart: success');
        notifyThemeCart();
        setTimeout(notifyThemeCart, 800);
      })
      .catch(function (e) {
        log('[DBG] stable add-to-cart failed:', e && e.message ? e.message : e);
      })
      .finally(function () {
        if (button) {
          button._mcpAdding = false;
          button.removeAttribute('data-mcp-adding');
        }
      });
  }

  function handleStableBogosAddClick(e) {
    var target = e.target;
    if (!target || !target.closest) return false;

    var addButton = target.closest('.mcp-bogos-stable-host .bogos-volume-discount-button-add');
    if (!addButton) return false;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var href = addButton.getAttribute('href') || getProductUrlForBogosElement(addButton);

    log('[DBG] stable product-link: click captured', href || '*** EMPTY ***');

    if (href && href !== '#') {
      window.location.href = href;
    }

    return true;
  }

  function setupStableBogosInteractions() {
    if (document._mcpStableBogosInteractions) return;
    document._mcpStableBogosInteractions = true;

    window.addEventListener('click', handleStableBogosAddClick, true);

    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      if (handleStableBogosAddClick(e)) return;

      var option = target.closest('.mcp-bogos-stable-host .bogos-vl-select-variant-option');
      if (option) {
        e.preventDefault();
        e.stopImmediatePropagation();
        selectStableBogosVariant(option);
        return;
      }

      var titleInput = target.closest('.mcp-bogos-stable-host .bogos-vl-select-variant-title-input');
      if (titleInput) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openStableBogosDropdown(titleInput);
        return;
      }

      var tier = target.closest('.mcp-bogos-stable-host .bogos-volume-discount_item-container');
      if (tier) {
        e.preventDefault();
        e.stopImmediatePropagation();
        updateStableBogosTierSelection(tier);
        return;
      }

    }, true);

    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.mcp-bogos-stable-host .bogos-vl-select-variant-dropdown')) {
        return;
      }

      document.querySelectorAll('.mcp-bogos-stable-host').forEach(function (host) {
        closeStableBogosDropdowns(host);
      });
    });
  }

  function setupCartRefresh() {
    if (document._mcpCartRefresh) return;
    document._mcpCartRefresh = true;

    document.addEventListener('click', function (e) {
      var el = e.target;

      while (el && el.nodeType === 1) {
        if (el.classList && el.classList.contains('bogos-volume-discount-button-add')) {
          var mount = getMountFromElement(el);

          if (mount) {
            activateBogosInteractionContext(mount);
            exposeSealedBogosView(getAnyBogosView(mount), 2000);
            setTimeout(notifyThemeCart, 1000);
            setTimeout(notifyThemeCart, 3000);
            return;
          }
        }

        el = el.parentNode;
      }
    }, true);
  }

  function postRenderAdjust() {
    /* NOTE: Do NOT manipulate DOM nodes inside BOGOS's rendered elements here.
       Any insertBefore/appendChild/removeChild inside .bogos-volume-discount-view
       triggers BOGOS's internal MutationObserver → "Delay rerender" cascade
       that clears all rendered widgets. */

    document.querySelectorAll('.MultipackTeaser__BogosMount').forEach(processBogosMount);

    setupStableBogosInteractions();
    setupCartRefresh();
    setupMultipackImageEvents();

    updateAllMultipackImages();
    applyStaticOfferDiscountBadges(document);

    setTimeout(updateAllMultipackImages, 300);
    setTimeout(function () { applyStaticOfferDiscountBadges(document); }, 300);
    setTimeout(updateAllMultipackImages, 1000);
  }

  function onBogosInitComplete() {
    postRenderAdjust();
  }

  function getBogosView(mount) {
    return mount && mount.querySelector('.' + BOGOS_VIEW_CLASS + '[data-product-handle][data-product-id]');
  }

  function getAnyBogosView(mount) {
    var stableHost = getStableBogosHost(mount, false);
    var stableView = stableHost && stableHost.querySelector('.' + SEALED_BOGOS_VIEW_CLASS);

    return stableView || (
      mount && mount.querySelector(
        '.' + BOGOS_VIEW_CLASS + ',' +
        '.' + SEALED_BOGOS_VIEW_CLASS
      )
    );
  }

  function hasUsefulBogosContent(view) {
    return !!(
      view &&
      view.children.length > 0 &&
      (
        view.querySelector('.bogos-volume-discount_item-container') ||
        view.querySelector('.bogos-volume-discount-item') ||
        view.querySelector('.bogos-volume-discount-button-add')
      )
    );
  }

  function syncFormStateToMarkup(view) {
    if (!view) return;

    view.querySelectorAll('input').forEach(function (input) {
      if (input.checked) {
        input.setAttribute('checked', 'checked');
      } else {
        input.removeAttribute('checked');
      }
    });

    view.querySelectorAll('option').forEach(function (option) {
      if (option.selected) {
        option.setAttribute('selected', 'selected');
      } else {
        option.removeAttribute('selected');
      }
    });
  }

  function restoreBogosViewSnapshot(mount, snapshotHtml) {
    if (!mount || !snapshotHtml) return false;

    var holder = document.createElement('div');
    holder.innerHTML = snapshotHtml;

    var restoredView = holder.firstElementChild;
    if (!restoredView) return false;

    restoredView.removeAttribute('id');
    restoredView._mcpGuarded = true;
    restoredView._mcpBogosProtected = true;
    restoredView.setAttribute('data-mcp-bogos-sealed', '1');
    restoredView.classList.add(SEALED_BOGOS_VIEW_CLASS);
    restoredView.classList.remove(BOGOS_VIEW_CLASS);
    restoredView.style.display = '';

    var stableHost = getStableBogosHost(mount, true);

    domWriteGuardBypass = true;
    try {
      stableHost.innerHTML = '';
      stableHost.appendChild(restoredView);
    } finally {
      domWriteGuardBypass = false;
    }

    processBogosMount(mount);
    return true;
  }

  function setActiveBogosTarget(mount) {
    var view = getBogosView(mount);
    if (!view) return null;

    activeBogosRenderView = view;
    view._mcpBogosProtected = false;
    view.classList.add(BOGOS_VIEW_CLASS);
    view.classList.remove(SEALED_BOGOS_VIEW_CLASS);
    view.removeAttribute('data-mcp-bogos-sealed');
    view.style.display = '';

    document.querySelectorAll('#bogos-volume-discount-view').forEach(function (el) {
      el.removeAttribute('id');
    });

    var pid = parseInt(view.getAttribute('data-product-id'), 10);
    var handle = view.getAttribute('data-product-handle');

    window.Shopify = window.Shopify || {};
    /* Use the full cached JSON when available — a partial {id, handle} object
       causes BOGOS to throw "Cannot read 'includes' of undefined" when its
       Delay-rerender fires before the /products/handle.js fetch completes. */
    var cachedJson = productJsonCache[handle];
    if (cachedJson) {
      window.Shopify.current_product = cachedJson;
      window.Shopify.product         = cachedJson;
    } else {
      window.Shopify.current_product = { id: pid, handle: handle };
      window.Shopify.product         = { id: pid, handle: handle };
    }

    view.id = 'bogos-volume-discount-view';

    return {
      view: view,
      pid: pid,
      handle: handle
    };
  }

  function getBogosDataFile(handle) {
    /* Fast path 1: per-handle cache */
    if (dataFileCache[handle]) {
      log('[DBG] getBogosDataFile: handle cache hit for', handle, '→', dataFileCache[handle]);
      return Promise.resolve(dataFileCache[handle]);
    }

    /* Fast path 2: global URL already known — no HTML fetch needed */
    if (cachedDataFileUrl) {
      log('[DBG] getBogosDataFile: global URL cache hit →', cachedDataFileUrl);
      dataFileCache[handle] = cachedDataFileUrl;
      return Promise.resolve(cachedDataFileUrl);
    }

    log('[DBG] getBogosDataFile: fetching /products/' + handle);
    return fetch('/products/' + handle, {
      credentials: 'same-origin'
    })
      .then(function (response) {
        log('[DBG] getBogosDataFile: /products/' + handle + ' → HTTP', response.status);
        return response.text();
      })
      .then(function (html) {
        var cdnMatches = html.match(/https?:\/\/cdn\.bogos\.io\/[^\s"'<>]+/g) || [];
        log('[DBG] getBogosDataFile: bogos CDN URLs found in HTML:', cdnMatches);
        var dataFile = cdnMatches.find(function (url) {
          return url.indexOf('freegifts_data') !== -1;
        });

        if (dataFile) {
          dataFileCache[handle] = dataFile;
          if (!cachedDataFileUrl) cachedDataFileUrl = dataFile; /* store globally */
          log('[DBG] getBogosDataFile: freegifts_data URL →', dataFile);
        } else {
          log('[DBG] getBogosDataFile: *** NO freegifts_data URL FOUND for', handle, '***');
        }

        return dataFile || '';
      })
      .catch(function (e) {
        log('[DBG] getBogosDataFile: fetch error for', handle, e && e.message);
        return '';
      });
  }

  function loadBogosDataFile(url) {
    return new Promise(function (resolve) {
      if (!url) {
        log('[DBG] loadBogosDataFile: no URL — skipping');
        resolve();
        return;
      }

      log('[DBG] loadBogosDataFile: removing old data scripts');
      document.querySelectorAll('script[data-mcp-bogos-data="1"]').forEach(function (script) {
        script.parentNode.removeChild(script);
      });

      log('[DBG] loadBogosDataFile: FGSECOMAPP before load =', typeof window.FGSECOMAPP, window.FGSECOMAPP);

      var fullSrc = url + (url.indexOf('?') !== -1 ? '&' : '?') + BOGOS_INJECT_TOKEN;
      log('[DBG] loadBogosDataFile: injecting script →', fullSrc);

      var script = document.createElement('script');
      script.setAttribute('data-mcp-bogos-data', '1');
      script.src = fullSrc;

      script.onload = function () {
        log('[DBG] loadBogosDataFile: script onload fired');
        log('[DBG] loadBogosDataFile: FGSECOMAPP after load =', typeof window.FGSECOMAPP, window.FGSECOMAPP ? Object.keys(window.FGSECOMAPP) : 'undefined');
        resolve();
      };

      script.onerror = function (e) {
        log('[DBG] loadBogosDataFile: *** script onerror ***', e);
        resolve();
      };

      document.head.appendChild(script);
    });
  }

  function waitForBogosContent(mount, timeout) {
    var view = getBogosView(mount);
    var label = view ? (view.getAttribute('data-product-handle') || '?') : 'NO-VIEW';

    log('[DBG] waitForBogosContent: START for', label, '| view children =', view ? view.children.length : 'N/A', '| timeout =', timeout);

    return new Promise(function (resolve) {
      if (!view) {
        log('[DBG] waitForBogosContent: no view element — resolving false');
        resolve(false);
        return;
      }

      if (hasUsefulBogosContent(view)) {
        sealBogosView(view);
        log('[DBG] waitForBogosContent: already has useful content — sealed + resolving true immediately');
        resolve(true);
        return;
      }

      var done = false;

      var observer = new MutationObserver(function () {
        if (hasUsefulBogosContent(view)) {
          if (done) return;
          done = true;
          observer.disconnect();
          clearTimeout(timer);
          sealBogosView(view);
          log('[DBG] waitForBogosContent: useful content appeared for', label, '— sealed + resolving true');
          resolve(true);
        }
      });

      observer.observe(view, {
        childList: true,
        subtree: true
      });

      var timer = setTimeout(function () {
        if (done) return;
        done = true;
        observer.disconnect();
        var hasContent = hasUsefulBogosContent(view);
        if (hasContent) {
          sealBogosView(view);
        }
        if (!hasContent && activeBogosRenderView === view) activeBogosRenderView = null;
        log('[DBG] waitForBogosContent: *** TIMEOUT for', label, '*** children =', view.children.length, '→ resolving', hasContent);
        resolve(hasContent);
      }, timeout || RENDER_TIMEOUT_MS);
    });
  }

  function enqueueBogosMount(mount) {
    if (!mount || mount._mcpBogosQueued || mount._mcpBogosRendered || mount._mcpBogosFailed) {
      var view = getBogosView(mount);
      var h = view ? view.getAttribute('data-product-handle') : '?';
      log('[DBG] enqueueBogosMount: SKIP', h, '| queued=', !!mount._mcpBogosQueued, 'rendered=', !!mount._mcpBogosRendered, 'failed=', !!mount._mcpBogosFailed);
      return;
    }

    var view = getBogosView(mount);
    if (!view) {
      log('[DBG] enqueueBogosMount: no bogos view in mount — skip');
      return;
    }

    var handle = view.getAttribute('data-product-handle');
    log('[DBG] enqueueBogosMount:', handle, '| children =', view.children.length);

    if (hasUsefulBogosContent(view)) {
      log('[DBG] enqueueBogosMount: already rendered, calling processBogosMount');
      mount._mcpBogosRendered = true;
      sealBogosView(view);
      processBogosMount(mount);
      guardRenderedMount(mount);
      return;
    }

    log('[DBG] enqueueBogosMount: queuing', handle, '| queue length before push =', renderQueue.length);
    mount._mcpBogosQueued = true;
    renderQueue.push(mount);
    log('[DBG] enqueueBogosMount: queue length after push =', renderQueue.length);
    processBogosQueue();
  }

  function processBogosQueue() {
    log('[DBG] processBogosQueue: renderInProgress =', renderInProgress, '| queue length =', renderQueue.length);
    if (renderInProgress) return;

    var mount = renderQueue.shift();
    if (!mount) {
      log('[DBG] processBogosQueue: queue empty');
      return;
    }

    var view = getBogosView(mount);
    log('[DBG] processBogosQueue: starting render for', view ? view.getAttribute('data-product-handle') : '?');
    renderInProgress = true;

    renderBogosMount(mount).then(function () {
      log('[DBG] processBogosQueue: renderBogosMount resolved, advancing queue');
      renderInProgress = false;
      processBogosQueue();
    });
  }

  function renderBogosMount(mount) {
    /* Extract view info WITHOUT assigning the id yet.
       Assigning id="bogos-volume-discount-view" to a view that was already
       populated by the collection-page scan triggers BOGOS Delay rerender,
       which clears the content. We defer the id assignment to only the first
       product (the one that actually injects the data script). */
    var view = getBogosView(mount);
    log('[DBG] renderBogosMount: mount =', mount, '| view =', view);

    if (!view) {
      log('[DBG] renderBogosMount: no view — aborting');
      renderInProgress = false;
      return Promise.resolve();
    }

    var handle = view.getAttribute('data-product-handle');

    if (!handle) {
      log('[DBG] renderBogosMount: no handle — aborting');
      renderInProgress = false;
      return Promise.resolve();
    }

    var teaser = mount.closest('.MultipackTeaser');
    var fallback = teaser && teaser.querySelector('[data-mp-fallback]');

    mount.style.display = '';
    if (fallback) fallback.style.display = 'none';

    log('[DBG] renderBogosMount: FGSECOMAPP before render =', typeof window.FGSECOMAPP);

    /* Fetch the CDN URL and the full product JSON in parallel.
       Use the pre-fetched JSON from productJsonCache when available —
       all JSONs are kicked off in parallel in initAll.              */
    return Promise.all([
      getBogosDataFile(handle),
      productJsonCache[handle]
        ? Promise.resolve(productJsonCache[handle])
        : fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .catch(function (e) { log('[DBG] product JSON fetch error:', e && e.message); return null; })
    ])
      .then(function (results) {
        var dataFile    = results[0];
        var productJson = results[1];

        log('[DBG] renderBogosMount: dataFile =', dataFile || '*** EMPTY ***');
        log('[DBG] renderBogosMount: productJson =', productJson
          ? ('id=' + productJson.id + ' variants=' + (productJson.variants && productJson.variants.length))
          : '*** NULL ***');

        if (productJson) {
          productJsonCache[handle] = productJson;
          window.Shopify = window.Shopify || {};
          window.Shopify.current_product = productJson;
          window.Shopify.product         = productJson;
          log('[DBG] renderBogosMount: set full Shopify.current_product for', handle);
        }

        if (!dataFile) {
          log('[DBG] renderBogosMount: *** no CDN URL — skipping loadBogosDataFile ***');
          return false;
        }

        /* Re-inject the data script for every product.
           Why: when freegifts_data loads, BOGOS's "volume discount core init" fires
           and wipes every .bogos-volume-discount-view that lacks an id. Trying to
           rely on a single inject + collection scan fails because the wipe happens
           before our queue gets to products 2-N.

           Why setActiveBogosTarget is called AFTER loadBogosDataFile:
           Setting id="bogos-volume-discount-view" on a view triggers BOGOS's
           "Delay rerender" immediately. If the id is set BEFORE the script loads,
           the Delay rerender fires against stale/wrong offer data → renders nothing.
           Setting the id AFTER the script loads means Delay rerender runs with the
           freshly loaded offer data + the correct Shopify.current_product → correct
           content appears reliably for every product in the queue.

           Performance: BOGOS_INJECT_TOKEN is constant per page session, so all
           16 re-injects share the same URL — products 2-N load from browser cache
           (near-instant) instead of making a new CDN round-trip each time. */
        log('[DBG] renderBogosMount: FGSECOMAPP preserved (NOT reset) =', typeof window.FGSECOMAPP);

        return loadBogosDataFile(dataFile).then(function () {
          log('[DBG] renderBogosMount: data script loaded — now setting id for', handle);
          var activeTarget = setActiveBogosTarget(mount);
          if (!activeTarget) return false;
          log('[DBG] renderBogosMount: id set, waiting for Delay rerender content...');
          return waitForBogosContent(mount, RENDER_TIMEOUT_MS);
        });
      })
      .then(function (hasContent) {
        log('[DBG] renderBogosMount: hasContent =', hasContent, 'for', handle);
        mount._mcpBogosQueued = false;

        if (hasContent) {
          mount._mcpBogosRendered = true;
          /* Seal: remove id so BOGOS Delay rerender cannot target this element
             when the next product's id is assigned. For skip-inject products the
             view never had an id so this is a safe no-op. */
          var renderedView = getBogosView(mount);
          if (hasUsefulBogosContent(renderedView)) {
            sealBogosView(renderedView);
            log('[DBG] renderBogosMount: sealed + detached view for', handle);
          } else {
            log('[DBG] renderBogosMount: source view already sealed or empty after wait for', handle);
          }
          processBogosMount(mount);
          guardRenderedMount(mount);
          postRenderAdjust();
        } else {
          log('[DBG] renderBogosMount: *** NO CONTENT — showing fallback for', handle, '***');
          mount._mcpBogosFailed = true;
          mount.style.display = 'none';
          if (fallback) fallback.style.display = '';
        }
      })
      .catch(function (e) {
        log('BOGOS render error:', e && e.message ? e.message : e);

        mount._mcpBogosQueued = false;
        mount._mcpBogosFailed = true;
        mount.style.display = 'none';
        if (fallback) fallback.style.display = '';
      });
  }

  function installStaticMultipackOfferStyles() {
    if (document.getElementById('mcp-static-multipack-offer-styles')) return;

    var style = document.createElement('style');
    style.id = 'mcp-static-multipack-offer-styles';
    style.textContent = [
      '[data-mp-card]{height:auto!important;min-height:0!important;}',
      '[data-mp-card] .ProductItem__Wrapper{height:auto!important;min-height:0!important;}',
      '[data-mp-static-clone-item]{height:auto!important;min-height:0!important;}',
      '[data-mp-card] .ProductItem__ImageWrapper,[data-mp-card] .AspectRatio{height:320px!important;min-height:0!important;max-height:320px!important;padding-bottom:0!important;display:flex!important;align-items:center!important;justify-content:center!important;overflow:hidden!important;}',
      '[data-mp-card] .AspectRatio:before{display:none!important;}',
      '[data-mp-card] [data-mp-main-image],[data-mp-card] .ProductItem__Image:not(.ProductItem__Image--alternate){position:static!important;display:block!important;width:100%!important;height:100%!important;max-width:78%!important;max-height:78%!important;object-fit:contain!important;object-position:center!important;transform:none!important;margin:auto!important;}',
      '[data-mp-card] .ProductItem__Info{position:relative!important;z-index:2!important;margin-top:22px!important;height:auto!important;min-height:0!important;}',
      '[data-mp-card] .ProductItem__Title{margin:0!important;line-height:1.15!important;text-align:center!important;}',
      '[data-mp-card] .ProductItem__Title span:not(.MultipackTeaser__TitleSubtitle){display:inline!important;}',
      '.MultipackTeaser__BogosMount{display:block!important;}',
      '.MultipackTeaser__StaticOffer{display:flex;flex-direction:column;gap:12px;margin-top:16px;}',
      '.MultipackTeaser__StaticOfferInfo{min-height:64px;border:1px solid #8f8f8f;border-radius:8px;padding:16px 22px;display:flex;align-items:center;justify-content:space-between;gap:16px;background:#fff;}',
      '.MultipackTeaser__StaticOfferLabel{font-weight:900;font-size:16px;line-height:1.2;color:#000;}',
      '.MultipackTeaser__StaticOfferPrice{display:grid!important;grid-template-columns:auto auto!important;grid-template-rows:auto auto!important;align-items:center!important;justify-content:end!important;column-gap:8px!important;row-gap:2px!important;text-align:right;white-space:nowrap;}',
      '.McpDiscountBadge{grid-column:1;grid-row:1 / span 2;display:inline-flex;align-items:center;justify-content:center;background:#FF2A3F;color:#fff;padding:6px 9px;border-radius:6px;font-size:13px;font-weight:900;line-height:1;white-space:nowrap;margin:0;}',
      '.MultipackTeaser__StaticOfferPrice .Price--highlight{grid-column:2;grid-row:1;font-size:16px!important;font-weight:900!important;color:#BA2323!important;line-height:1.1!important;margin:0!important;text-align:right!important;}',
      '.MultipackTeaser__StaticOfferCompare{grid-column:2;grid-row:2;font-size:14px!important;font-weight:400!important;color:#9B9B9B!important;text-decoration:line-through!important;text-decoration-thickness:1px!important;text-decoration-color:#9B9B9B!important;line-height:1.1!important;margin:0!important;text-align:right!important;}',
      '.MultipackTeaser__StaticOfferCTA{min-height:54px;width:100%;display:flex;align-items:center;justify-content:center;border-radius:6px;background:#000;color:#fff!important;font-weight:900;text-decoration:none!important;text-align:center;padding:14px 20px;}',
      '.MultipackTeaser__StaticOfferCTA:hover{background:#1f1f1f;color:#fff!important;}',
      '.MultipackTeaser .ProductItem__Title span.MultipackTeaser__TitleSubtitle{display:block!important;margin-top:6px;font-size:13px!important;line-height:1.35!important;font-weight:400!important;color:#9b9b9b!important;text-transform:none!important;}',
      '@media (max-width: 1000px){[data-mp-card] .ProductItem__ImageWrapper,[data-mp-card] .AspectRatio{height:280px!important;max-height:280px!important;}}',
      '@media (max-width: 640px){[data-mp-card] .ProductItem__ImageWrapper,[data-mp-card] .AspectRatio{height:240px!important;max-height:240px!important;}.MultipackTeaser__StaticOfferInfo{padding:14px 16px;}.MultipackTeaser__StaticOfferLabel,.MultipackTeaser__StaticOfferPrice{font-size:15px;}}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }


  function parseStaticOfferMoneyText(text) {
    var value = String(text || '').replace(/\s/g, '');
    var matches = value.match(/[\d.,]+/g);
    var numeric;

    if (!matches || !matches.length) return null;

    numeric = matches[matches.length - 1];

    if (numeric.indexOf(',') !== -1 && numeric.indexOf('.') !== -1) {
      if (numeric.lastIndexOf(',') > numeric.lastIndexOf('.')) {
        numeric = numeric.replace(/\./g, '').replace(',', '.');
      } else {
        numeric = numeric.replace(/,/g, '');
      }
    } else if (numeric.indexOf(',') !== -1) {
      numeric = numeric.replace(/\./g, '').replace(',', '.');
    } else {
      numeric = numeric.replace(/,/g, '');
    }

    numeric = parseFloat(numeric);

    return isFinite(numeric) ? numeric : null;
  }

  function applyStaticOfferDiscountBadges(root) {
    (root || document).querySelectorAll('.MultipackTeaser__StaticOfferPrice').forEach(function (priceBox) {
      var saleEl;
      var compareEl;
      var salePrice;
      var comparePrice;
      var discount;
      var badge;

      if (priceBox.querySelector('.McpDiscountBadge')) return;

      saleEl = priceBox.querySelector('.Price--highlight');
      compareEl = priceBox.querySelector('.MultipackTeaser__StaticOfferCompare');

      if (!saleEl || !compareEl) return;

      salePrice = parseStaticOfferMoneyText(saleEl.textContent);
      comparePrice = parseStaticOfferMoneyText(compareEl.textContent);

      if (!salePrice || !comparePrice || comparePrice <= salePrice) return;

      discount = Math.round(((comparePrice - salePrice) / comparePrice) * 100);
      if (!discount || discount <= 0) return;

      badge = document.createElement('span');
      badge.className = 'McpDiscountBadge';
      badge.textContent = '-' + discount + '%';

      priceBox.insertBefore(badge, saleEl);
    });
  }

  function getCardProductLink(card, handle) {
    var link = card && card.querySelector('a[href*="/products/"]');
    var href = link && link.getAttribute('href');

    if (!href && handle) href = '/products/' + handle;
    if (!href) href = '#';

    return href.split('#')[0] || href;
  }

  function normalizeCardTitle(card) {
    var title = card && card.querySelector('.ProductItem__Title');
    var subtitle = title && title.querySelector('span');

    if (!title || !subtitle) return;

    subtitle.classList.add('MultipackTeaser__TitleSubtitle');
  }

  function copyStaticOffer(offer) {
    var config = {};

    Object.keys(STATIC_MULTIPACK_DEFAULT_OFFER).forEach(function (key) {
      config[key] = STATIC_MULTIPACK_DEFAULT_OFFER[key];
    });

    Object.keys(offer || {}).forEach(function (key) {
      config[key] = offer[key];
    });

    return config;
  }

  function normalizeStaticOfferList(value) {
    if (!value) return [];

    if (Array.isArray(value)) {
      return value.length ? value.map(copyStaticOffer) : [];
    }

    if (value.offers && Array.isArray(value.offers)) {
      return normalizeStaticOfferList(value.offers);
    }

    return [copyStaticOffer(value)];
  }

  function parseStaticOfferJson(value) {
    if (!value) return null;

    try {
      return normalizeStaticOfferList(JSON.parse(value));
    } catch (error) {
      log('[DBG] static multipack: invalid offer JSON', error && error.message ? error.message : error);
    }

    return null;
  }


  function normalizeFgMoneyCents(value) {
    if (value == null || value === '') return null;
    if (typeof value === 'number' && isFinite(value)) {
      /* BOGOS stores product variant prices as EUR numbers/strings in FGSECOMAPP,
         while Shopify product JSON stores cents. Treat small numeric values as EUR. */
      return value < 1000 ? Math.round(value * 100) : Math.round(value);
    }

    value = String(value).replace(/\s/g, '').replace('€', '').replace(',', '.');
    value = parseFloat(value);

    if (!isFinite(value)) return null;
    return value < 1000 ? Math.round(value * 100) : Math.round(value);
  }

  function getCompactSizeFromText(text) {
    var match = String(text || '').match(/\b\d+(?:[,.]\d+)?\s?(?:g|kg|ml|l)\b/i);
    return match ? match[0].replace(/\s+/g, '').toLowerCase() : '';
  }

  function getDiscountPercentFromFgTier(tier) {
    var discount = tier && tier.discount;
    var type = discount && String(discount.type || '').toLowerCase();
    var value = discount && discount.value != null ? parseFloat(discount.value) : null;

    if (type === 'percentage' && isFinite(value)) return value;

    value = parseFloat((tier && (tier.discountPercent || tier.discount_percentage || tier.percent)) || '');
    return isFinite(value) ? value : null;
  }


  function getFgOfferTitle(discount, tier, quantity) {
    var title = tier && (
      tier.title ||
      tier.offer_title ||
      tier.offerTitle ||
      tier.name ||
      tier.label ||
      tier.description ||
      tier.discount_title ||
      tier.discountTitle
    );

    if (!title && discount) {
      title = discount.offer_title ||
        discount.offerTitle ||
        discount.discount_title ||
        discount.discountTitle ||
        discount.title ||
        discount.name ||
        discount.description;
    }

    title = String(title || '').trim();
    return title || ((quantity || 1) + 'er Set');
  }

  function getFgDiscountProductEntry(discount, handle, productId) {
    var conditions = discount && discount.condition && discount.condition.products;
    var productEntry = null;

    if (!conditions || !conditions.length) return null;

    conditions.some(function (condition) {
      var value = condition && condition.value;
      if (!value) return false;

      Object.keys(value).some(function (key) {
        var product = value[key];
        var productHandle = product && product.handle;
        var productID = product && product.id;

        if (
          (handle && productHandle === handle) ||
          (productId && String(productID) === String(productId)) ||
          (productId && String(key) === String(productId))
        ) {
          productEntry = product;
          return true;
        }

        return false;
      });

      return !!productEntry;
    });

    return productEntry;
  }

  function pickFgVariantForTier(productEntry, tier) {
    var variants = (productEntry && productEntry.variants) || [];
    var sizeNeedle = getCompactSizeFromText(tier && (tier.title || tier.name || tier.label));
    var matched;

    if (!variants.length) return null;

    if (sizeNeedle) {
      matched = variants.filter(function (variant) {
        return String(variant && variant.title || '').replace(/\s+/g, '').toLowerCase().indexOf(sizeNeedle) !== -1;
      });
      if (matched.length) variants = matched;
    }

    /* Important: keep the same pricing base as BOGOS preview.
       FGSECOMAPP may include discounted/sale variants in the list, for example
       "Very Very Strawberry - 50% / 90g" at 4.50. If we pick the cheapest
       matching variant, collection price becomes half of the BOGOS admin preview.
       BOGOS preview uses the first matching configured variant, so do the same. */
    return variants[0] || null;
  }

  function getStaticMultipackOffersFromFGSECOMAPP(handle, productId) {
    var app = window.FGSECOMAPP;
    var discounts = app && (app.discounts || app.current_volume_discounts || app.currentVolumeDiscounts);
    var offers = [];

    if (!discounts || !discounts.length) return null;

    discounts.forEach(function (discount) {
      var type = String((discount && discount.type) || '').toLowerCase();
      var productEntry;
      var tiers;

      if (type && type !== 'volume' && type !== 'volume_discount') return;

      productEntry = getFgDiscountProductEntry(discount, handle, productId);
      if (!productEntry) return;

      tiers = discount.discount || discount.discounts || discount.tiers || [];
      if (!tiers || !tiers.length) return;

      tiers.forEach(function (tier, tierIndex) {
        var fgVariant = pickFgVariantForTier(productEntry, tier);
        var quantity = parseInt(tier.quantity || tier.qty || tier.required_quantity, 10) || 1;
        var discountPercent = getDiscountPercentFromFgTier(tier);
        var unitPrice = normalizeFgMoneyCents(fgVariant && fgVariant.price);
        var compareAtCents = unitPrice ? unitPrice * quantity : null;
        var priceCents = compareAtCents && discountPercent != null
          ? Math.round(compareAtCents * (100 - discountPercent) / 100)
          : null;
        var tierTitle = getFgOfferTitle(discount, tier, quantity);
        var size = getCompactSizeFromText(tierTitle);
        var offer = {
          /* Card label source of truth: BOGOS app tier/offer title. */
          title: tierTitle,
          label: tierTitle,
          quantity: quantity,
          discountPercent: discountPercent != null ? discountPercent : undefined,
          priceCents: priceCents,
          compareAtCents: compareAtCents,
          variantId: fgVariant && fgVariant.id,
          variant: 'first',
          imageUrl: fgVariant && fgVariant.image,
          imageAlt: fgVariant && fgVariant.title,
          imageTier: offers.length + 1,
          _fgDiscountId: discount.id,
          _fgTierId: tier.id || tierIndex + 1
        };

        if (size) offer.variantTitleIncludes = [size];
        offers.push(offer);
      });
    });

    return offers.length ? offers : null;
  }

  function ensureFGSECOMAPPReady(handle) {
    if (window.FGSECOMAPP && (window.FGSECOMAPP.discounts || window.FGSECOMAPP.current_volume_discounts)) {
      return Promise.resolve(window.FGSECOMAPP);
    }

    return getBogosDataFile(handle)
      .then(function (dataFile) {
        if (!dataFile) return null;
        return loadBogosDataFile(dataFile).then(function () { return window.FGSECOMAPP || null; });
      })
      .catch(function (error) {
        log('[DBG] FGSECOMAPP load failed for', handle, error && error.message ? error.message : error);
        return null;
      });
  }

  function getStaticMultipackOffersFromMarkup(card) {
    var mount = getStaticOfferMount(card);
    var attrValue = null;
    var script;
    var offers;

    if (!card) return null;
    if (card._mcpStaticOffersFromMarkup) return normalizeStaticOfferList(card._mcpStaticOffersFromMarkup);

    [card, mount].some(function (node) {
      if (!node || !node.getAttribute) return false;
      attrValue = (
        node.getAttribute('data-mp-static-offers') ||
        node.getAttribute('data-mp-offers') ||
        node.getAttribute('data-mp-multipack-offers')
      );
      return !!attrValue;
    });

    offers = parseStaticOfferJson(attrValue);
    if (!offers) {
      script = card.querySelector('script[type="application/json"][data-mp-static-offers],script[type="application/json"][data-mp-offers],script[type="application/json"][data-mp-multipack-offers]');
      offers = parseStaticOfferJson(script && script.textContent);
    }

    if (offers && offers.length) {
      card._mcpStaticOffersFromMarkup = offers;
      return offers;
    }

    return null;
  }

  function getStaticMultipackOffers(handle, card) {
    var productId = card && (
      card.getAttribute('data-mp-product-id') ||
      card.getAttribute('data-product-id') ||
      (getBogosView(getStaticOfferMount(card)) && getBogosView(getStaticOfferMount(card)).getAttribute('data-product-id'))
    );
    var fgOffers = getStaticMultipackOffersFromFGSECOMAPP(handle, productId);
    var cardTitle = '';
    var titleEl = card && card.querySelector('.ProductItem__Title');

    if (titleEl) {
      cardTitle = titleEl.textContent.toLowerCase();
    }

    /* Manager-side hidden offers filter.
       Still backend-only: we only remove specific BOGOS backend offers from the
       list; no local fallback/config/default offers are used. */
    if (
      cardTitle.indexOf('clear protein') !== -1 &&
      fgOffers &&
      fgOffers.length
    ) {
      fgOffers = fgOffers.filter(function (offer) {
        var title = String(offer.title || '').toLowerCase().trim();

        return (
          title !== '10x proben' &&
          title !== '5x proben' &&
          title !== '10 x proben' &&
          title !== '5 x proben'
        );
      });
    }

    /* Source of truth: BOGOS backend only (window.FGSECOMAPP).
       No local JS config, no markup JSON, no hardcoded rules, no default offer. */
    if (fgOffers && fgOffers.length) return normalizeStaticOfferList(fgOffers);

    log('[DBG] static multipack: no backend offer in FGSECOMAPP for', handle || productId || 'unknown');
    return [];
  }

  function getStaticOfferMount(card) {
    return card && (
      card.querySelector('[data-mp-bogos-mount]') ||
      card.querySelector('[data-mp-static-ready]') ||
      card.querySelector('.MultipackTeaser__BogosMount')
    );
  }

  function resetStaticOfferCard(card, offerIndex) {
    var staticOffer;
    var mount;
    var fallback;

    if (!card) return;

    card.removeAttribute('data-mp-static-split-done');
    card.removeAttribute('data-mp-static-image-tier');
    card.removeAttribute('data-mp-static-image-url');
    card.removeAttribute('data-mp-static-image-alt');
    card.removeAttribute('data-mp-current-tier');
    card.removeAttribute('data-mp-current-image');
    card.setAttribute('data-mp-static-offer-index', String(offerIndex || 0));

    staticOffer = card.querySelector('[data-mp-static-offer]');
    if (staticOffer && staticOffer.parentNode) staticOffer.parentNode.removeChild(staticOffer);

    mount = getStaticOfferMount(card);
    if (mount) {
      mount.innerHTML = '';
      mount.style.display = '';
      mount.setAttribute('data-mp-bogos-mount', '');
      mount.removeAttribute('data-mp-static-ready');
      mount.removeAttribute('data-mp-static-offer-title');
    }

    fallback = card.querySelector('[data-mp-fallback]');
    if (fallback) fallback.style.display = '';
  }

  function getStaticOfferGridItem(card) {
    if (!card || !card.closest) return card;

    return card.closest(
      '.Grid__Cell,' +
      '.ProductList__Item,' +
      '.CollectionInner__Product,' +
      '.CollectionMain__Product,' +
      '[data-product-card-wrapper],' +
      '[data-product-item]'
    ) || card;
  }

  function getStaticSplitCards(sourceCard, sourceItem) {
    var splitId = sourceCard && sourceCard.getAttribute('data-mp-static-split-id');
    var parent = sourceItem && sourceItem.parentNode;
    var cards = [];

    if (!splitId || !parent) return cards;

    Array.prototype.forEach.call(parent.querySelectorAll('[data-mp-card]'), function (card) {
      if (card.getAttribute('data-mp-static-split-id') === splitId) cards.push(card);
    });

    return cards;
  }

  function ensureStaticMultipackOfferCards(sourceCard, offers) {
    var cards = [];
    var sourceItem;
    var insertAfter;
    var splitId;

    if (!sourceCard) return cards;

    sourceItem = getStaticOfferGridItem(sourceCard);

    if (sourceCard.getAttribute('data-mp-static-split-done') === '1') {
      cards = getStaticSplitCards(sourceCard, sourceItem);
      return cards.length ? cards.slice(0, offers.length) : [sourceCard];
    }

    splitId = 'mp-static-' + Date.now() + '-' + Math.floor(Math.random() * 100000);
    sourceCard.setAttribute('data-mp-static-split-done', '1');
    sourceCard.setAttribute('data-mp-static-split-id', splitId);
    sourceCard.setAttribute('data-mp-static-offer-index', '0');
    if (sourceItem && sourceItem !== sourceCard && sourceItem.setAttribute) {
      sourceItem.setAttribute('data-mp-static-split-id', splitId);
    }
    cards.push(sourceCard);
    insertAfter = sourceItem || sourceCard;

    offers.slice(1).forEach(function (_offer, index) {
      var cloneItem = insertAfter.cloneNode ? (sourceItem || sourceCard).cloneNode(true) : null;
      var clone = cloneItem && cloneItem.matches && cloneItem.matches('[data-mp-card]')
        ? cloneItem
        : cloneItem && cloneItem.querySelector && cloneItem.querySelector('[data-mp-card]');

      if (!cloneItem || !clone || !insertAfter.parentNode) return;

      resetStaticOfferCard(clone, index + 1);
      clone.setAttribute('data-mp-static-clone', '1');
      clone.setAttribute('data-mp-static-split-done', '1');
      clone.setAttribute('data-mp-static-split-id', splitId);
      if (cloneItem.setAttribute) {
        cloneItem.setAttribute('data-mp-static-clone-item', '1');
        cloneItem.setAttribute('data-mp-static-split-id', splitId);
      }

      insertAfter.parentNode.insertBefore(cloneItem, insertAfter.nextSibling);
      cards.push(clone);
      insertAfter = cloneItem;
    });

    return cards;
  }

  function getIncludedMultipackVariant(productJson, config) {
    var variants = productJson && productJson.variants;
    var available;
    var matched;

    if (!variants || !variants.length) return null;

    available = variants.filter(function (variant) {
      return variant && variant.available !== false;
    });

    if (config && config.variantId) {
      matched = (available.length ? available : variants).filter(function (variant) {
        return String(variant && variant.id) === String(config.variantId);
      });

      if (matched.length) available = matched;
    }

    if (config && config.variantTitleIncludes && config.variantTitleIncludes.length) {
      matched = (available.length ? available : variants).filter(function (variant) {
        var title = String((variant && variant.title) || '').toLowerCase();

        return config.variantTitleIncludes.every(function (needle) {
          return title.indexOf(String(needle || '').toLowerCase()) !== -1;
        });
      });

      if (matched.length) available = matched;
    }

    if (config && config.variantTitleExcludes && config.variantTitleExcludes.length) {
      matched = (available.length ? available : variants).filter(function (variant) {
        var title = String((variant && variant.title) || '').toLowerCase();

        return !config.variantTitleExcludes.some(function (needle) {
          return title.indexOf(String(needle || '').toLowerCase()) !== -1;
        });
      });

      if (matched.length) available = matched;
    }

    available = available.length ? available : variants;

    if (config && config.variant === 'first') return available[0] || null;

    return available.reduce(function (best, variant) {
      var variantPrice = parseInt(variant.price, 10) || 0;
      var bestPrice = best ? parseInt(best.price, 10) || 0 : 0;

      if (!best) return variant;
      if (config && config.variant === 'lowest') return variantPrice < bestPrice ? variant : best;
      return variantPrice > bestPrice ? variant : best;
    }, null);
  }

  function getMultipackDiscountPercent(productJson, config) {
    if (config && config.discountPercent != null) return config.discountPercent;
    return null;
  }

  function getFallbackPriceHtml(card) {
    var fallback = card && card.querySelector('[data-mp-fallback]');
    var priceList = fallback && fallback.querySelector('.ProductItem__PriceList');

    return priceList && priceList.innerHTML ? priceList.innerHTML.trim() : '';
  }

  function normalizeMultipackMoveText(value) {
    return String(value || '')
      .toLowerCase()
      .normalize ? String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') : String(value || '').toLowerCase();
  }

  function normalizeMultipackMoveTitle(value) {
    return normalizeMultipackMoveText(value)
      .replace(/[^a-z0-9]+/g, '')
      .trim();
  }

  function normalizeMultipackMoveOffer(value) {
    var text = normalizeMultipackMoveText(value)
      .replace(/\ber\s*set\b/g, 'x')
      .replace(/\bset\b/g, '')
      .replace(/\s+/g, '')
      .replace(/[^a-z0-9]/g, '');

    text = text.replace(/^(\d+)x(\d+)g$/, '$1x$2');

    return text;
  }

  function getMultipackMoveCellData(cell) {
    var card = cell && cell.querySelector && cell.querySelector('.MultipackTeaser');
    var titleEl = cell && cell.querySelector && cell.querySelector('.ProductItem__Title');
    var offerEl = cell && cell.querySelector && cell.querySelector('.MultipackTeaser__StaticOfferLabel');
    var productLink = cell && cell.querySelector && cell.querySelector('a[href*="/products/"]');
    var href = productLink && productLink.getAttribute('href');
    var handleMatch = href && href.match(/\/products\/([^?#/]+)/);
    var handle = handleMatch ? handleMatch[1] : '';

    return {
      cell: cell,
      card: card,
      title: (
        (card && (
          card.getAttribute('data-product-title') ||
          card.getAttribute('data-mp-product-title')
        )) ||
        (titleEl ? titleEl.innerText : '')
      ),
      offer: (
        (card && (
          card.getAttribute('data-mp-static-offer-title') ||
          card.getAttribute('data-mcp-static-offer-title') ||
          card.getAttribute('data-offer-title')
        )) ||
        (cell && (
          cell.getAttribute('data-mp-static-offer-title') ||
          cell.getAttribute('data-mcp-static-offer-title') ||
          cell.getAttribute('data-offer-title')
        )) ||
        (offerEl ? offerEl.innerText : '')
      ),
      handle: handle
    };
  }

  function moveSelectedMultipacksToBottomByMap() {
    var productList = document.querySelector('.ProductList');
    var cells;
    var targets;
    var moved = 0;

    if (!productList) return false;

    targets = [
      { titleKey: 'proteinshake', offerKey: '3x300' },
      { titleKey: 'proteinfrappe', offerKey: '2x270', handles: ['protein-coffee', 'protein-frappe'] },
      { titleKey: 'proteinmatcha', offerKey: '2x270', handles: ['protein-matcha'] }
    ];

    cells = Array.prototype.slice.call(productList.children).filter(function (cell) {
      return cell && cell.nodeType === 1 && cell.querySelector && cell.querySelector('.MultipackTeaser');
    }).map(getMultipackMoveCellData);

    cells.forEach(function (data) {
      var titleKey = normalizeMultipackMoveTitle(data.title);
      var offerKey = normalizeMultipackMoveOffer(data.offer);
      var handleKey = String(data.handle || '').toLowerCase();

      var shouldMove = targets.some(function (target) {
        var titleMatches = titleKey.indexOf(target.titleKey) !== -1;
        var handleMatches = target.handles && target.handles.indexOf(handleKey) !== -1;
        var offerMatches = offerKey === target.offerKey;

        return offerMatches && (titleMatches || handleMatches);
      });

      if (!shouldMove || !data.cell || data.cell.parentNode !== productList) return;

      productList.appendChild(data.cell);
      moved += 1;
    });

    log('[DBG] moveSelectedMultipacksToBottomByMap: moved', moved);

    return moved > 0;
  }

  function scheduleMoveSelectedMultipacksToBottomByMap() {
    if (document._mcpMoveSelectedByMapScheduled) return;
    document._mcpMoveSelectedByMapScheduled = true;

    [300, 800, 1500, 2500, 4000, 6500].forEach(function (delay) {
      setTimeout(moveSelectedMultipacksToBottomByMap, delay);
    });
  }

  function getShopCurrencyCode() {
    return (
      window.Shopify && window.Shopify.currency && window.Shopify.currency.active
    ) || (
      window.Shopify && window.Shopify.Checkout && window.Shopify.Checkout.currency
    ) || (
      window.Shopify && window.Shopify.shopCurrency
    ) || 'EUR';
  }

  function getShopMoneyFormat() {
    return (
      window.theme && (window.theme.moneyFormat || window.theme.money_format)
    ) || (
      window.Shopify && (window.Shopify.money_format || window.Shopify.moneyFormat)
    ) || '';
  }

  function formatStaticMoney(cents) {
    var value = parseInt(cents, 10);
    var moneyFormat;
    var locale;
    var currency;

    if (!isFinite(value)) return '';

    moneyFormat = getShopMoneyFormat();
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && moneyFormat) {
      try {
        return window.Shopify.formatMoney(value, moneyFormat);
      } catch (_) {}
    }

    currency = getShopCurrencyCode();
    locale = (document.documentElement && document.documentElement.lang) || navigator.language || 'de-DE';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value / 100);
    } catch (_) {
      return (value / 100).toFixed(2).replace('.', ',') + ' ' + currency;
    }
  }

  function getVariantSizeLabel(variant) {
    var text = variant && variant.title ? variant.title : '';
    var match = text.match(/\b\d+(?:[,.]\d+)?\s?(?:g|kg|ml|l)\b/i);

    return match ? match[0].replace(/\s+/g, ' ') : '';
  }

  function getStaticOfferMoneyCents(value) {
    if (value == null || value === '') return null;
    if (typeof value === 'number' && isFinite(value)) return Math.round(value);

    value = String(value).replace(/\s/g, '').replace('€', '').replace(',', '.');
    value = parseFloat(value);

    return isFinite(value) ? Math.round(value * 100) : null;
  }

  function getStaticMultipackLabel(config, variant) {
    return String((config && (config.title || config.label)) || '').trim();
  }

  function getStaticMultipackPriceHtml(productJson, config) {
    var variant = getIncludedMultipackVariant(productJson, config);
    var quantity = config && config.quantity ? config.quantity : 1;
    var discountPercent = getMultipackDiscountPercent(productJson, config);
    var basePrice = variant && parseInt(variant.price, 10);
    var compareAt = null;
    var discountedPrice = null;

    /* Multi-shop / multi-currency:
       price source is Shopify product JSON from the current storefront/market;
       discount source is BOGOS backend (window.FGSECOMAPP). */
    if (!basePrice || discountPercent == null) return '';

    compareAt = basePrice * quantity;
    discountedPrice = Math.round(compareAt * (100 - discountPercent) / 100);

    if (!discountedPrice) return '';

    return [
      '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible>',
        escapeHtml(formatStaticMoney(discountedPrice)),
      '</span>',
      compareAt && compareAt > discountedPrice ? '<span class="MultipackTeaser__StaticOfferCompare">' + escapeHtml(formatStaticMoney(compareAt)) + '</span>' : ''
    ].join('');
  }

  function renderStaticMultipackOfferForCard(card, productJson, offer, offerIndex) {
    var mount = getStaticOfferMount(card);
    var originalView = getBogosView(mount);
    var handle = originalView && originalView.getAttribute('data-product-handle');
    var variant = getIncludedMultipackVariant(productJson, offer);
    var label = getStaticMultipackLabel(offer, variant);
    var priceHtml = getStaticMultipackPriceHtml(productJson, offer);
    var href = getCardProductLink(card, handle || (productJson && productJson.handle));
    var fallback = card && card.querySelector('[data-mp-fallback]');

    if (!mount) return;

    if (!label || !priceHtml) {
      log('[DBG] static multipack: skipped card because backend title/price is missing for', handle || (productJson && productJson.handle));
      var item = getStaticOfferGridItem(card);
      if (item && item.style) item.style.display = 'none';
      return;
    }

    normalizeCardTitle(card);
    applyStaticMultipackImage(card, offer, offerIndex || 0);

    mount.innerHTML = [
      '<div class="MultipackTeaser__StaticOffer" data-mp-static-offer>',
        '<div class="MultipackTeaser__StaticOfferInfo">',
          '<div class="MultipackTeaser__StaticOfferLabel">' + escapeHtml(label) + '</div>',
          '<div class="MultipackTeaser__StaticOfferPrice">',
            priceHtml,
          '</div>',
        '</div>',
        '<a class="MultipackTeaser__StaticOfferCTA" href="' + escapeHtml(href) + '">Zum Angebot</a>',
      '</div>'
    ].join('');

    applyStaticOfferDiscountBadges(mount);

    mount.style.display = '';
    mount.setAttribute('data-mp-static-ready', '1');
    mount.setAttribute('data-mp-static-offer-title', label);
    mount.removeAttribute('data-mp-bogos-mount');
    if (card) {
      card.setAttribute('data-mp-static-offer-title', label);
      if (variant && variant.id) card.setAttribute('data-mp-static-variant-id', String(variant.id));
    }

    if (fallback) fallback.style.display = 'none';
  }

  function renderStaticMultipackOffer(mount, productJson) {
    var originalView = getBogosView(mount);
    var handle = originalView && originalView.getAttribute('data-product-handle');
    var card = getCardFromElement(mount);
    var offers = getStaticMultipackOffers(handle || (productJson && productJson.handle), card);
    var cards;

    if (!offers || !offers.length) {
      log('[DBG] static multipack: skipped because backend returned no offers for', handle || (productJson && productJson.handle));

      if (!hasFGSECOMAPPBackendOffers()) {
        log('[DBG] static multipack: backend object is not ready yet; keeping card visible and retrying');
        setTimeout(function () {
          if (mount && !mount._mcpStaticRetryStarted) {
            mount._mcpStaticRetryStarted = true;
            renderStaticMultipackMountsWhenBackendReady([mount]);
          }
        }, 500);
        return;
      }

      var item = getStaticOfferGridItem(card);
      if (item && item.style) item.style.display = 'none';
      return;
    }

    cards = ensureStaticMultipackOfferCards(card, offers);

    cards.forEach(function (offerCard, index) {
      renderStaticMultipackOfferForCard(offerCard, productJson, offers[index] || offers[0], index);
    });

    scheduleMoveSelectedMultipacksToBottomByMap();
  }

  function loadStaticProductJson(handle) {
    if (!handle) return Promise.resolve(null);
    if (productJsonCache[handle]) return Promise.resolve(productJsonCache[handle]);

    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('product json failed: ' + response.status);
        return response.json();
      })
      .then(function (json) {
        if (json) productJsonCache[handle] = json;
        return json;
      });
  }

  function renderStaticMultipackMount(mount) {
    var view = getBogosView(mount);
    var handle = view && view.getAttribute('data-product-handle');

    Promise.all([
      ensureFGSECOMAPPReady(handle),
      loadStaticProductJson(handle)
    ])
      .then(function (results) {
        renderStaticMultipackOffer(mount, results[1]);
      })
      .catch(function (error) {
        log('[DBG] static multipack: product json / FGSECOMAPP failed for', handle, error && error.message ? error.message : error);
        var card = getCardFromElement(mount);
        var item = getStaticOfferGridItem(card);
        if (item && item.style) item.style.display = 'none';
      });
  }

  function adjustBogosAnchorScroll() {
    if (window.location.hash !== '#bogos-volume-discount-view') return;

    setTimeout(function () {
      var target = document.getElementById('bogos-volume-discount-view') ||
        document.querySelector('.bogos-volume-discount-view,.mcp-bogos-volume-discount-view,[data-mp-bogos-mount]');
      var header = document.querySelector('.shopify-section--header,.Header,header[role="banner"],.SiteHeader');
      var headerHeight = header && header.getBoundingClientRect ? Math.ceil(header.getBoundingClientRect().height) : 0;
      var offset = Math.max(90, headerHeight + 30);

      if (!target || !target.getBoundingClientRect) return;

      window.scrollTo({
        top: Math.max(0, window.pageYOffset + target.getBoundingClientRect().top - offset),
        behavior: 'smooth'
      });
    }, 120);
  }

  function setupBogosAnchorOffset() {
    if (document._mcpBogosAnchorOffset) return;
    document._mcpBogosAnchorOffset = true;

    window.addEventListener('load', adjustBogosAnchorScroll);
    window.addEventListener('hashchange', adjustBogosAnchorScroll);
    document.addEventListener('DOMContentLoaded', adjustBogosAnchorScroll);
    setTimeout(adjustBogosAnchorScroll, 600);
  }

  function hasFGSECOMAPPBackendOffers() {
    var app = window.FGSECOMAPP;
    var discounts = app && (app.discounts || app.current_volume_discounts || app.currentVolumeDiscounts);

    return !!(discounts && discounts.length);
  }

  function waitForFGSECOMAPPBackend(handle, timeout) {
    timeout = timeout || 12000;

    return ensureFGSECOMAPPReady(handle).then(function () {
      return new Promise(function (resolve) {
        var startedAt = Date.now();

        function check() {
          if (hasFGSECOMAPPBackendOffers()) {
            resolve(true);
            return;
          }

          if (Date.now() - startedAt >= timeout) {
            resolve(false);
            return;
          }

          setTimeout(check, 100);
        }

        check();
      });
    });
  }

  function getHandleFromMount(mount) {
    var view = getBogosView(mount);
    return view && view.getAttribute('data-product-handle');
  }

  function renderStaticMultipackMountsWhenBackendReady(mounts) {
    mounts = Array.prototype.slice.call(mounts || []).filter(function (mount) {
      return mount && !mount._mcpStaticRenderStarted;
    });

    if (!mounts.length) return;

    var firstHandle = getHandleFromMount(mounts[0]);

    waitForFGSECOMAPPBackend(firstHandle, 12000).then(function (ready) {
      if (!ready) {
        log('[DBG] static multipack: FGSECOMAPP backend offers are still missing after wait; keeping cards untouched');
        return;
      }

      mounts.forEach(function (mount) {
        mount._mcpStaticRenderStarted = true;
        renderStaticMultipackMount(mount);
      });
    });
  }

  function setupStaticMultipackMountObserver() {
    if (document._mcpStaticMultipackMountObserver) return;
    document._mcpStaticMultipackMountObserver = true;

    new MutationObserver(function (mutations) {
      var mounts = [];

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;

          if (node.matches && node.matches('[data-mp-bogos-mount]')) {
            mounts.push(node);
          }

          if (node.querySelectorAll) {
            node.querySelectorAll('[data-mp-bogos-mount]').forEach(function (mount) {
              mounts.push(mount);
            });
          }
        });
      });

      if (mounts.length) renderStaticMultipackMountsWhenBackendReady(mounts);
    scheduleMoveSelectedMultipacksToBottomByMap();
    }).observe(document.documentElement || document.body, {
      childList: true,
      subtree: true
    });
  }

  function initAll() {
    var mounts = document.querySelectorAll('[data-mp-bogos-mount]');
    log('[DBG] initAll static multipack: found', mounts.length, 'mounts');

    window.Shopify = window.Shopify || {};
    installStaticMultipackOfferStyles();
    setupBogosAnchorOffset();
    setupStaticMultipackMountObserver();
    updateAllMultipackImages();

    renderStaticMultipackMountsWhenBackendReady(mounts);
    scheduleMoveSelectedMultipacksToBottomByMap();
  }

  function watchMount(mountEl) {
    var bogosEl = mountEl.querySelector('.bogos-volume-discount-view');
    var teaser = mountEl.closest('.MultipackTeaser');
    var fallback = teaser && teaser.querySelector('[data-mp-fallback]');

    if (!bogosEl) {
      mountEl.style.display = 'none';
      if (fallback) fallback.style.display = '';
      return;
    }

    function hasContent() {
      return hasUsefulBogosContent(bogosEl);
    }

    if (hasContent()) {
      sealBogosView(bogosEl);
      processBogosMount(mountEl);
      guardRenderedMount(mountEl);
      postRenderAdjust();
      return;
    }

    var observer = new MutationObserver(function () {
      if (hasContent()) {
        observer.disconnect();
        clearTimeout(timer);
        postRenderAdjust();
      }
    });

    observer.observe(bogosEl, {
      childList: true,
      subtree: true
    });

    var timer = setTimeout(function () {
      observer.disconnect();

      if (!hasContent() && !mountEl._mcpBogosQueued && !mountEl._mcpBogosRendered) {
        mountEl.style.display = 'none';
        if (fallback) fallback.style.display = '';
      }
    }, RENDER_TIMEOUT_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);

  function moveSelectedMultipacksToBottom() {
  var productList = document.querySelector('.ProductList');
  if (!productList) return;

  var rules = [
    { title: 'Protein Shake', offer: '3er Set 300 g' },
    { title: 'Protein Frappé', offer: '2er Set 270g' },
    { title: 'Protein Matcha', offer: '2er Set 270 g' }
  ];

  rules.forEach(function (rule) {
    document.querySelectorAll('.MultipackTeaser').forEach(function (card) {
      var titleEl = card.querySelector('.ProductItem__Title');
      var offerEl = card.querySelector('.MultipackTeaser__StaticOfferLabel');

      var title = titleEl ? titleEl.innerText : '';
      var offer = offerEl ? offerEl.innerText.trim() : '';

      if (
        title.indexOf(rule.title) !== -1 &&
        offer === rule.offer
      ) {
        var cell = card.closest('.Grid__Cell');

        if (cell && cell.parentNode === productList) {
          productList.appendChild(cell);
        }
      }
    });
  });
}

function bootSelectedMultipackSorting() {
  moveSelectedMultipacksToBottom();

  setTimeout(moveSelectedMultipacksToBottom, 300);
  setTimeout(moveSelectedMultipacksToBottom, 800);
  setTimeout(moveSelectedMultipacksToBottom, 1500);
  setTimeout(moveSelectedMultipacksToBottom, 3000);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootSelectedMultipackSorting);
} else {
  bootSelectedMultipackSorting();
}

document.addEventListener('shopify:section:load', bootSelectedMultipackSorting);
document.addEventListener('collection:rerendered', bootSelectedMultipackSorting);
})();
